import { toArray } from 'rise-ui/utils/array.js';

export default function filterEmptyModelRuns(modelRuns) {
  return toArray(modelRuns).filter(modelRun => modelRun.temporalStartDate);
}
